export const SET_LOADING = 'rewards/achievement-tasks/set_loading';
export const UPDATE_TASK = 'rewards/achievement-tasks/update_taks';
export const SET_TASKS = 'rewards/achievement-tasks/set_tasks';
export const ADD_TASK = 'rewards/achievement-tasks/add_task';



// WEBPACK FOOTER //
// ./src/store/rewards/achievement_tasks/types.js